module.exports = __webpack_public_path__ + "img/design2.ccd09548.png";